export interface Article {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  content: string;
  author: string;
  publishDate: string;
  views: number;
  tags: string[];
  summary: string;
}

export const articles: Article[] = [
  {
    id: "art-1",
    title: "2026年暑期档最强电影推荐：这10部不容错过",
    category: "电影",
    categorySlug: "dianying",
    coverImage: "https://readdy.ai/api/search-image?query=Cinema%20movie%20theater%20with%20film%20posters%20on%20wall%2C%20warm%20ambient%20lighting%2C%20entertainment%20atmosphere%2C%20clean%20minimal%20background%2C%20editorial%20photography%20style&width=1200&height=600&seq=article-cover-01&orientation=landscape",
    author: "影视编辑小王",
    publishDate: "2026-08-01",
    views: 35600,
    tags: ["电影推荐", "暑期档", "影评", "新片"],
    summary: "暑期档是每年电影市场的重头戏，2026年的暑期档更是精彩纷呈。从科幻巨制到温情喜剧，从国产大片到引进佳作，我们为您精选了10部最值得期待的电影。",
    content: `<p>暑期档是每年电影市场的重头戏，2026年的暑期档更是精彩纷呈。从科幻巨制到温情喜剧，从国产大片到引进佳作，我们为您精选了10部最值得期待的电影。</p>
<h2>1. 《流浪地球3》—— 国产科幻新高度</h2>
<p>作为《流浪地球》系列的第三部作品，本片延续了前两部的宏大世界观，将故事推向更加深远的宇宙空间。郭帆导演再次突破国产科幻电影的技术边界，为观众呈现了一场视觉盛宴。</p>
<p>影片讲述了地球在逃离太阳系过程中遇到的全新危机。人类需要在有限的时间内做出关乎命运的重大抉择。吴京、刘德华等原班人马悉数回归，更有国际演员加盟，阵容强大。</p>
<h2>2. 《无名之辈2》—— 小人物的温暖故事</h2>
<p>饶晓志导演的《无名之辈》续集终于来了！这一次，故事背景搬到了更大的城市，但不变的是对普通人生存状态的细腻观察和温情表达。笑中带泪的叙事风格依旧是最大看点。</p>
<h2>3. 《封神第二部》—— 神话史诗再续</h2>
<p>乌尔善导演十年磨一剑，《封神第一部》获得口碑票房双丰收后，第二部备受期待。本片将聚焦武王伐纣的核心战役，神仙斗法的场面将更加宏大震撼。</p>
<h2>观影建议</h2>
<p>暑期档影片扎堆上映，建议大家根据自己的喜好合理安排观影计划。科幻迷首选《流浪地球3》，喜欢温情故事的可以看《无名之辈2》，追求视觉震撼的《封神第二部》不容错过。</p>`,
  },
  {
    id: "art-2",
    title: "《庆余年》第三季深度解析：权谋棋局谁主沉浮",
    category: "电视剧",
    categorySlug: "dianshiju",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20ancient%20palace%20interior%2C%20warm%20candlelight%2C%20mysterious%20court%20atmosphere%2C%20period%20drama%20aesthetic%2C%20clean%20minimal%20background&width=1200&height=600&seq=article-cover-02&orientation=landscape",
    author: "剧评人老张",
    publishDate: "2026-07-25",
    views: 42800,
    tags: ["庆余年", "剧情解析", "权谋", "热播剧"],
    summary: "《庆余年》第三季自开播以来热度持续攀升，剧中复杂的权谋线和人物关系让观众欲罢不能。本文深入分析本季的核心剧情走向和人物命运。",
    content: `<p>《庆余年》第三季自开播以来热度持续攀升，剧中复杂的权谋线和人物关系让观众欲罢不能。本文深入分析本季的核心剧情走向和人物命运。</p>
<h2>范闲的成长蜕变</h2>
<p>如果说前两季的范闲还是一个被动卷入权谋漩涡的年轻人，第三季的范闲已经逐渐成长为一个能够在棋局中主动布局的棋手。他从北齐归来后，对京都的局势有了更加清醒的认识。</p>
<p>本季中范闲面临的最大挑战来自内部——庆帝对他的态度发生了微妙变化。曾经的父子情深被权力的阴影所笼罩，这种复杂的情感纠葛成为本季最动人的看点之一。</p>
<h2>权谋棋局的新玩家</h2>
<p>第三季引入了多个新角色，每个都有自己独特的立场和目的。北齐势力的渗透、监察院的内部斗争、各大世家之间的明争暗斗，让整个故事格局更加宏大。</p>
<h2>剧情预测</h2>
<p>从目前的剧情走向来看，范闲最终可能需要在亲情、友情和家国大义之间做出艰难的选择。而庆帝的真实身份和最终目的，也将在本季揭晓。</p>`,
  },
  {
    id: "art-3",
    title: "《黑神话：悟空》为什么能成为现象级游戏",
    category: "游戏",
    categorySlug: "youxi",
    coverImage: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20game%20art%20with%20mythological%20Chinese%20warrior%20in%20ancient%20temple%2C%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20game%20concept%20art%20style%2C%20clean%20minimal%20background&width=1200&height=600&seq=article-cover-03&orientation=landscape",
    author: "游戏观察员小李",
    publishDate: "2026-07-30",
    views: 52100,
    tags: ["黑神话悟空", "国产游戏", "游戏评测", "文化"],
    summary: "《黑神话：悟空》上线后迅速成为全球瞩目的现象级游戏。本文从画面、玩法、文化内涵等多个维度分析这款游戏成功的原因。",
    content: `<p>《黑神话：悟空》上线后迅速成为全球瞩目的现象级游戏。这款由游戏科学工作室历时多年打造的国产3A大作，不仅在国内引发了空前的讨论热度，更在全球游戏市场掀起了一股"西游热"。</p>
<h2>画面与技术的突破</h2>
<p>《黑神话：悟空》采用了虚幻引擎5打造，其画面水准达到了国际一线3A游戏的水平。从光影效果到材质纹理，从角色建模到场景设计，每一个细节都经过精心打磨。游戏中对中国古典建筑、山水景观的还原度极高，让玩家仿佛置身于一幅活生生的中国水墨画卷之中。</p>
<h2>文化自信的表达</h2>
<p>这款游戏最令人称道的地方在于其深厚的文化底蕴。游戏没有简单地照搬《西游记》的故事，而是在原著基础上进行了全新的演绎和重构。妖怪的设计融合了中国民间传说和现代审美，每一个Boss都有自己独特的背景故事。</p>
<h2>对国产游戏行业的启示</h2>
<p>《黑神话：悟空》的成功证明了中国游戏开发者完全有能力打造世界级的3A作品。它不仅是一个游戏的胜利，更是中国文化在全球范围内的一次精彩输出。</p>`,
  },
  {
    id: "art-4",
    title: "纪录片推荐：5部改变你世界观的自然纪录片",
    category: "纪录片",
    categorySlug: "jilupian",
    coverImage: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Earth%20nature%20landscape%20with%20wildlife%2C%20breathtaking%20natural%20scenery%2C%20documentary%20style%20photography%2C%20warm%20natural%20lighting%2C%20clean%20minimal%20background&width=1200&height=600&seq=article-cover-04&orientation=landscape",
    author: "纪录片爱好者阿明",
    publishDate: "2026-07-18",
    views: 18500,
    tags: ["纪录片推荐", "自然", "BBC", "科普"],
    summary: "好的纪录片可以打开一扇认识世界的新窗口。本文选取5部最值得观看的自然纪录片，带你领略地球的壮美与生命的奇迹。",
    content: `<p>好的纪录片可以打开一扇认识世界的新窗口。在这个信息爆炸的时代，静下心来观看一部优秀的纪录片，是一种难得的精神享受。本文选取5部最值得观看的自然纪录片，带你领略地球的壮美与生命的奇迹。</p>
<h2>1. 《地球脉动》系列</h2>
<p>BBC出品的《地球脉动》系列堪称自然纪录片的巅峰之作。从极地到赤道，从深海到高山，每一帧画面都是摄影艺术的杰作。第三季更是采用了8K超高清拍摄技术，画面质量达到了前所未有的高度。</p>
<h2>2. 《蓝色星球》系列</h2>
<p>海洋覆盖了地球表面的71%，但人类对海洋的了解还非常有限。《蓝色星球》系列带领观众深入海洋世界，揭示那些不为人知的生命奇迹。</p>
<h2>3. 《我们的星球》</h2>
<p>Netflix与WWF合作打造的这部纪录片，不仅展现了自然的壮美，更呼吁人们关注环境保护。精美的画面背后是对人类未来的深刻思考。</p>
<h2>为什么值得看</h2>
<p>这些纪录片不仅提供了视觉享受，更重要的是它们改变了我们看待世界的方式。当我们看到地球另一端生命的挣扎与美丽时，会更加珍惜我们所拥有的一切。</p>`,
  },
  {
    id: "art-5",
    title: "鬼灭之刃完结：一部动画如何征服全球观众",
    category: "动漫",
    categorySlug: "dongman",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20anime%20art%20with%20sword%20warriors%20in%20dramatic%20battle%20pose%2C%20vibrant%20animation%20style%2C%20warm%20and%20dark%20color%20contrast%2C%20clean%20minimal%20background&width=1200&height=600&seq=article-cover-05&orientation=landscape",
    author: "动漫评论员小陈",
    publishDate: "2026-08-03",
    views: 67300,
    tags: ["鬼灭之刃", "动漫完结", "日漫", "现象级"],
    summary: "《鬼灭之刃》动画系列正式完结，这部现象级作品如何在短短几年间席卷全球？本文回顾其成功之路。",
    content: `<p>《鬼灭之刃》动画系列在无限城篇后正式画上句号。从2019年第一季播出至今，这部作品创造了日本动画史上的诸多纪录，其影响力远远超出了二次元圈层。</p>
<h2>从漫画到动画的完美蜕变</h2>
<p>吾峠呼世晴的原作漫画本身质量过硬，但真正让《鬼灭之刃》火遍全球的是ufotable制作的动画。精良的制作水准、流畅的战斗场面、恰到好处的配乐，让每一集都堪称艺术品。</p>
<h2>情感内核的普世价值</h2>
<p>《鬼灭之刃》最打动人心的地方在于其对"家族之爱"的深刻刻画。炭治郎对妹妹祢豆子的守护、鬼杀队成员之间生死与共的情谊、甚至反派角色背后令人心碎的故事，都让观众产生了强烈的情感共鸣。</p>
<h2>文化输出的成功案例</h2>
<p>《鬼灭之刃》中大量融入了日本传统文化元素——和服、浮世绘、武士道精神等。这些文化元素通过精彩的动画呈现，让全球观众对日本文化产生了浓厚兴趣。</p>`,
  },
];